// extracted by mini-css-extract-plugin
export var col = "pageHero-module--col--f5165";
export var content = "pageHero-module--content--248a0";
export var image = "pageHero-module--image--b03b8";
export var lede = "pageHero-module--lede--3f98d";
export var quote = "pageHero-module--quote--205d0";
export var row = "pageHero-module--row--7115e";
export var wrapper = "pageHero-module--wrapper--4b538";